// extracted by mini-css-extract-plugin
module.exports = {"icon":"ArchivedMarker-icon-ccd8765ceeace9aa1320c43257474f80"};